<script setup lang="ts">

definePageMeta({
  layout: "blog",
  public: true,
})

</script>

<template>
<h1>blog content</h1>
</template>

<style scoped lang="scss">

</style>
